<template>
    <v-app id="inspire">
        <v-card class="overflow-hidden" height="100%">
            <v-navigation-drawer v-model="drawer" v-if="isLoggedIn" app>
                <v-list dense nav>
                    <v-list-item-group active-class="blue--text text--accent-3">
                        <v-list-item :to="{ name: 'dashboard' }">
                            <v-list-item-icon>
                                <v-icon>mdi-view-dashboard</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Dashboard</v-list-item-title>
                        </v-list-item>
                        <v-list-group :value="false" prepend-icon="mdi-contacts" no-action>
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title>Contact Center</v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <v-list-item :to="{ name: 'clients' }">
                                <v-list-item-icon>
                                    <v-icon>mdi-account-multiple</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Clientes</v-list-item-title>
                            </v-list-item>         
                            <v-list-item :to="{ name: 'campaigns' }">
                                <v-list-item-icon>
                                    <v-icon>mdi-send</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Campañas</v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                        <v-list-item disabled>
                            <v-list-item-icon>
                                <v-icon>mdi-image-multiple</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Galería</v-list-item-title>
                        </v-list-item>
                        <v-list-item disabled>
                            <v-list-item-icon>
                                <v-icon>mdi-chart-bar</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Reportes</v-list-item-title>
                        </v-list-item>
                        <v-list-item disabled>
                            <v-list-item-icon>
                                <v-icon>mdi-history</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>Historial</v-list-item-title>
                        </v-list-item>
                        <v-list-group :value="false" prepend-icon="settings" no-action>
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title>Configuración</v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <v-list-item :to="{ name: 'wsserver' }">
                                <v-list-item-icon>
                                    <v-icon>mdi-server</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Servidor WhatsApp</v-list-item-title>
                            </v-list-item>
                            <!-- External Links -->
                            <v-list-item :href="hangfireUrl" target="_blank">
                                <v-list-item-icon>
                                    <v-icon>mdi-calendar-clock</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Tareas</v-list-item-title>
                            </v-list-item>
                            <v-list-item :href="whatsappEngineUrl" target="_blank">
                                <v-list-item-icon>
                                    <v-icon>mdi-robot</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>WhatsApp Engine</v-list-item-title>
                            </v-list-item>
                            <v-list-item disabled>
                                <v-list-item-icon>
                                    <v-icon>mdi-account-multiple</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Usuarios</v-list-item-title>
                            </v-list-item>
                        </v-list-group>
                    </v-list-item-group>
                </v-list>
                <template v-slot:append>
                    <div class="pa-2">
                        <v-btn color="secondary" @click="logout" block> Logout </v-btn>
                    </div>
                </template>
            </v-navigation-drawer>
            <v-app-bar app>
                <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title>WhatsApp Notifier</v-toolbar-title>
                <v-spacer></v-spacer> <!-- Mantiene todo lo que sigue hacia la derecha -->

                <v-select v-model="selectedBranch" item-text="name"
                item-value="id" v-if="isLoggedIn" :items="branches" label="Select Branch" solo dense outlined auto
                    append-icon="mdi-chevron-down" prepend-icon="mdi-store" class="my-auto"
                    style="max-width: 200px;"></v-select>
            </v-app-bar>
            <v-main>
                <v-container fluid fill-height>
                    <v-slide-y-transition mode="out-in">
                        <router-view />
                    </v-slide-y-transition>
                </v-container>
            </v-main>
        </v-card>
        <v-footer blue height="auto">
            <v-layout justify-center>
                <v-flex text-md-right>
                    <v-card flat tile color="primary" class="white--text">
                        <v-card-text class="white--text pt-0">APITechnology &copy;2024</v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-footer>
    </v-app>
</template>

<script>
import router from "./router/index";
import {
    getAuth,
    onAuthStateChanged,
    signOut,
} from "firebase/auth";
import {
    firebaseApp
} from "../firebase";
import {
    getFirestore,
    doc,
    getDoc,
    getDocsFromCache,
    getDocs,
    setDoc,
    deleteDoc,
    collection,
} from "firebase/firestore";
import { API_CONFIG } from "./config/api";

const auth = getAuth();
const db = getFirestore(firebaseApp);

export default {
    data: () => ({
        drawer: true,
        isLoggedIn: false,
        group: null,
        branches: [],
        selectedBranch: null,
    }),
    created() {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                this.isLoggedIn = true;
                this.defaultBranch(user.uid);
                this.getBranches(user.uid);
            } else {
                this.isLoggedIn = false;

            }
        });
    },
    computed: {
        hangfireUrl() {
            return API_CONFIG.ENDPOINTS.HANGFIRE_DASHBOARD;
        },
        whatsappEngineUrl() {
            return API_CONFIG.ENDPOINTS.WHATSAPP_ENGINE_DASHBOARD;
        }
    },
    watch: {
        selectedBranch(newValue) {
            this.$store.commit('setSelectedBranch', newValue);
        }
    },
    methods: {
        async logout() {
            signOut(auth)
                .then(() => {
                    console.log("se deslogueo");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async defaultBranch(uid) {
            const docRef = doc(db, "users", uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                this.selectedBranch = docSnap.data().defaultBranchId;
                this.$store.commit('setSelectedBranch', this.selectedBranch);
            } else {
                console.log("No such document!");
            }
        },
        async getBranches(uid) {
            this.branches = [];
            const querySnapshot = await getDocs(
                collection(db, "branchUsers")
            );
            querySnapshot.forEach((doc) => {
                if (doc.data().userId == uid) {
                    this.branches.push(
                    {
                        name: doc.data().branchName,
                        id: doc.data().branchId
                    }    
                    );
                }
            });
        },
    },
};
</script>
